import {EntityService} from '../../../../service/EntityService';

export class UserPermisionDataAppService extends EntityService {
  static entity = 'app/user-permision-data';
   
}
